module.exports = __webpack_public_path__ + "static/img/city10.ff12f37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city10.jpg
// module id = OelP
// module chunks = 0